"use client";

import React from "react";
import Image from "../../assets/images/CyberSafe.png"

export function Compliance() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container md:max-w-5xl lg:max-w-7xl mx-auto">
        <div className="grid grid-cols-1 gap-y-12 md:grid-flow-row md:grid-cols-2 md:items-center md:gap-x-12 lg:gap-x-20">
          <div>
            <h1 className="text-4xl  leading-[1.2] md:text-[30px] lg:text-[30px] max-w-[450px] leading-[1.4] mb-6">
            Stärken Sie Ihre Sicherheit mit umfassenden Lösungen für Compliance und Strategie
            </h1>
            <p className="mb-6 md:mb-8 md:text-md">
            Unsere Dienstleistungen im Bereich Compliance & Sicherheitsstrategie stellen sicher, dass Ihr
              Organisation die Industriestandards erfüllt. Wir bieten gründliche IT
              Audits, Zertifizierungen und Mitarbeiterschulungen zur Verbesserung Ihrer
              Sicherheitslage zu verbessern.
            </p>
            <div className="grid grid-cols-1 gap-6 py-2 sm:grid-cols-2">
              <div>
                <h6 className="mb-3 text-md font-semibold leading-[1] md:mb-4 md:text-xl">
                  IT Audits
                </h6>
                <p className="max-w-[250px]">
                Identifizieren Sie Schwachstellen und stellen Sie die Einhaltung der Vorschriften mit unseren
                von Experten geleiteten IT-Audit-Dienstleistungen.
                </p>
              </div>
              <div>
                <h6 className="mb-3 text-md font-semibold leading-[1] md:mb-4 md:text-xl">
                Zertifizierungen
                </h6>
                <p className="max-w-[250px]"  >
                Erreichen Sie wichtige Sicherheitszertifizierungen, um Ihr
                Engagement für den Schutz sensibler Informationen.
                </p>
              </div>
            </div>
          </div>
          <div>
            <img
              src = {Image}
              className="w-full object-cover rounded-xl"
              alt="Relume placeholder image"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
